module.exports = __webpack_public_path__ + "static/media/icons_Bilan Main et Doigts.35271bc9.svg";